/* eslint-disable import/no-named-as-default */
import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { ConnectedPodcastDemographicsContainer } from '../PodcastDemographicsContainer';
import { ConnectedPodcastStartsStreamsContainer } from '../PodcastStartsStreamsContainer';
import { ConnectedPodcastListeners } from '../PodcastListeners';
import { ConnectedPodcastFollowers } from '../PodcastFollowers';
import { selectDateRange, selectDatesAvailable } from '../../../store/selectors';
import { ConnectedDateRangeSelector } from '../../Shared/DateRangeSelector';
import { requestCsv } from '../../../store/downloadCsv';
import { updateDateRange } from '../../../store/updateDateRange';
import { DateRangeWithLabel, DataRange, CSVType, ReduxState } from '../../../types';
import { IntlShape, defineMessage, injectIntl } from 'react-intl';
import { TSFix } from '@spotify-internal/ts-migration-utils/types';

type Props = {
  dateRange?: DateRangeWithLabel;
  datesAvailable?: DataRange;
  podcastId: string;
  requestCsv(type: CSVType, requestedFields: string[]): void;
  updateDateRange(startDate: string, endDate: string, label: string): void;
  intl: IntlShape;
};

class InternationalizedPodcastAudience extends PureComponent<Props> {
  UNSAFE_componentWillMount() {
    const label = this.props.dateRange!.label;
    if (label === 'First 30 days' || label === 'First 90 days') {
      const endDate = this.props.datesAvailable!.until;
      this.props.updateDateRange(
        moment(endDate)
          .subtract(6, 'days')
          .format('YYYY-MM-DD'),
        moment(endDate).format('YYYY-MM-DD'),
        this.props.intl.formatMessage(
          defineMessage({
            id: 'podcast-audience.default-date-range',
            defaultMessage: 'Last 7 days',
          }),
        ),
      );
    }
  }

  render() {
    return (
      <Fragment>
        <ConnectedDateRangeSelector
          showFirstDaysOptions={false}
          downloadDataAsCsv={
            /* istanbul ignore next */ () => {
              this.props.requestCsv('podcast', [
                'starts',
                'streams',
                'listeners',
                'followers',
                'age',
                'gender',
                'countries',
              ]);
            }
          }
        />
        <ConnectedPodcastStartsStreamsContainer
          data-qa="podcast-starts-streams"
          podcastId={this.props.podcastId}
        />
        <ConnectedPodcastListeners data-qa="podcast-listeners" podcastId={this.props.podcastId} />
        <ConnectedPodcastFollowers data-qa="podcast-followers" podcastId={this.props.podcastId} />
        <ConnectedPodcastDemographicsContainer
          data-qa="podcast-demographics"
          podcastId={this.props.podcastId}
        />
      </Fragment>
    );
  }
}

function mapStateToProps(state: ReduxState) {
  return {
    dateRange: selectDateRange(state),
    datesAvailable: selectDatesAvailable(state),
  };
}
const actions = {
  requestCsv,
  updateDateRange,
};

export const PodcastAudience = injectIntl(InternationalizedPodcastAudience as TSFix);
export const ConnectedPodcastAudience = connect(
  mapStateToProps,
  actions,
)(InternationalizedPodcastAudience);
